import React from 'react';

export const StatusBadge = ({ status }) => {
  const MAP = {
    draft:              { label: 'Draft',              cls: 'draft' },
    invoice_requested:  { label: 'Invoice Req.',       cls: 'pending' },
    payment_pending:    { label: 'Payment Due',        cls: 'due' },
    payment_received:   { label: 'Paid',               cls: 'paid' },
    documents_pending:  { label: 'Docs Pending',       cls: 'docs' },
    under_review:       { label: 'Under Review',       cls: 'review' },
    signature_pending:  { label: 'Signature Pending',  cls: 'progress' },
    signature_review:   { label: 'Signature Review',   cls: 'progress' },
    completed:          { label: 'Completed',          cls: 'complete' },
    cancelled:          { label: 'Cancelled',          cls: 'cancelled' },
  };
  const { label, cls } = MAP[status] || { label: status || 'Unknown', cls: 'draft' };
  return (
    <span className={`admin-status ${cls}`} data-testid={`status-badge-${status}`}>
      <span className="admin-status-dot" />
      {label}
    </span>
  );
};

export const MetricCard = ({ label, value, sub, icon: Icon, color = 'green' }) => (
  <div className="admin-metric-card" data-testid={`metric-${label?.toLowerCase().replace(/\s+/g,'-')}`}>
    <div style={{ flex: 1, minWidth: 0 }}>
      <div className="admin-metric-label">{label}</div>
      <div className="admin-metric-value">{value}</div>
      {sub && <div className="admin-metric-sub">{sub}</div>}
    </div>
    {Icon && (
      <div className={`admin-metric-icon ${color}`}>
        <Icon />
      </div>
    )}
  </div>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="admin-page-head">
    <div>
      <h1 className="admin-page-title">{title}</h1>
      {subtitle && <p className="admin-page-subtitle">{subtitle}</p>}
    </div>
    {children && <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>{children}</div>}
  </div>
);

export const SectionHeader = ({ title, count, icon: Icon, color = 'purple' }) => (
  <div className="admin-section-header">
    <div className={`admin-section-icon ${color}`}>
      <Icon />
    </div>
    <span className="admin-section-title">{title}</span>
    {count != null && <span className="admin-section-count">{count} Orders</span>}
  </div>
);

export const AdminCard = ({ children, className = '', ...props }) => (
  <div className={`admin-card ${className}`} {...props}>
    {children}
  </div>
);
